/** Checks if the URL contains the base Wistia URL Embed */
export const wistiaEmbed = new RegExp(/fast\.wistia\.(?:net|com)\/embed/, 'im');

/** Checks if the URL contains the Wistia URL Embed Iframe */
export const wistiaEmbedIFrame = new RegExp(/fast\.wistia\.(?:net|com)\/embed\/iframe/, 'im');

const isWistiaEmbed = (url: string, type?: 'iframe') => {
  if (type === 'iframe') {
    const currentIFrameURL = wistiaEmbedIFrame.exec(url);

    return currentIFrameURL && currentIFrameURL?.[0] ? true : false;
  }

  const currentURL = wistiaEmbed.exec(url);

  return currentURL && currentURL?.[0] ? true : false;
};

export default isWistiaEmbed;
